import { get } from "lodash"

export const getCurrency = (_, props) => get(props, "currency")
